import React, { Component } from 'react'
import { RenderTenantList } from './utils/RenderTenantList'
import { ParseTenantInfo } from './utils/ParseTenantInfo'

export default class ProgramReport extends Component {
  constructor(props) {
    super(props)

    this.requirements = {
      oneWeb: [],
      oneWebIntegration: [],
      oneWebFrontend: [],
      digitalCommercePlatform: [],
      commerceIntegration: [],
      digitalBusinessPlatform: [],
      digitalAssistant: [],
      afterSales: [],
      mercedesMeHome: [],
      services: [],
      other: [],
    }
  }

  getRequirements = () => {
    const { allTenants } = this.props

    this.requirements = {
      oneWeb: [],
      oneWebIntegration: [],
      oneWebFrontend: [],
      digitalCommercePlatform: [],
      commerceIntegration: [],
      digitalBusinessPlatform: [],
      digitalAssistant: [],
      afterSales: [],
      mercedesMeHome: [],
      services: [],
      other: [],
    }

    Object.keys(allTenants).forEach((acronym) => {
      const tenant = allTenants[acronym]
      switch (tenant.programName) {
        case 'ONEWEB':
          this.requirements.oneWeb.push(ParseTenantInfo(tenant))
          break
        case 'ONEWEB_INTEGRATION':
          this.requirements.oneWebIntegration.push(ParseTenantInfo(tenant))
          break
        case 'ONEWEB_FRONTEND':
          this.requirements.oneWebFrontend.push(ParseTenantInfo(tenant))
          break
        case 'COMMERCE':
          this.requirements.digitalCommercePlatform.push(
            ParseTenantInfo(tenant),
          )
          break
        case 'COMMERCE_INTEGRATION':
          this.requirements.commerceIntegration.push(ParseTenantInfo(tenant))
          break
        case 'PLATFORM':
          this.requirements.digitalBusinessPlatform.push(
            ParseTenantInfo(tenant),
          )
          break
        case 'DIGITAL_ASSISTANT':
          this.requirements.digitalAssistant.push(ParseTenantInfo(tenant))
          break
        case 'AFTER_SALES':
          this.requirements.afterSales.push(ParseTenantInfo(tenant))
          break
        case 'MERCEDES_ME_HOME':
          this.requirements.mercedesMeHome.push(ParseTenantInfo(tenant))
          break
        case 'SERVICES':
          this.requirements.services.push(ParseTenantInfo(tenant))
          break
        case 'OTHERS':
          this.requirements.other.push(ParseTenantInfo(tenant))
          break
      }
    })
  }

  render = () => {
    const { allTenants } = this.props

    this.getRequirements()

    if (allTenants && Object.keys(allTenants).length === 0) {
      return (
        <div className="page-body__section">
          <div className="loader-container">
            <wb-spinner mode="dark" />
          </div>
        </div>
      )
    }
    return (
      <div className="page-body__section">
        <h3 className="wb-type-heading-m page-body__margin-bottom-s">
          Program
        </h3>

        <wb-accordion theme="light" prevent-mobile-flyout>
          <RenderTenantList title="OneWeb" list={this.requirements.oneWeb} />
          <RenderTenantList
            title="OneWeb Integration"
            list={this.requirements.oneWebIntegration}
          />
          <RenderTenantList
            title="OneWeb Frontend"
            list={this.requirements.oneWebFrontend}
          />
          <RenderTenantList
            title="Commerce"
            list={this.requirements.digitalCommercePlatform}
          />
          <RenderTenantList
            title="Commerce Integration"
            list={this.requirements.commerceIntegration}
          />
          <RenderTenantList
            title="Platform"
            list={this.requirements.digitalBusinessPlatform}
          />
          <RenderTenantList
            title="Digital Assistant"
            list={this.requirements.digitalAssistant}
          />
          <RenderTenantList
            title="After Sales"
            list={this.requirements.afterSales}
          />
          <RenderTenantList
            title="Mercedes Me Home"
            list={this.requirements.mercedesMeHome}
          />
          <RenderTenantList
            title="Services"
            list={this.requirements.services}
          />
          <RenderTenantList title="Others" list={this.requirements.other} />
        </wb-accordion>
      </div>
    )
  }
}
